import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const QUOTES = [
  { quote: "Ordered at 5:40, unpacking by 6. I picked up my kids from Mount Royal and dinner still beat us home.", name: "Sarah M.", hood: "Beltline" },
  { quote: "The picker texted me a photo of the avocados before swapping them. Who does that?", name: "Jordan K.", hood: "Kensington" },
  { quote: "I stopped meal-planning around Deerfoot traffic. Freshly just handles it.", name: "Priya R.", hood: "Bridgeland" },
  { quote: "Fastest delivery I've had in Calgary, and the produce actually looks hand-picked.", name: "Marcus T.", hood: "Mission" },
  { quote: "Between shifts at Foothills, this is the only way I grocery shop now.", name: "Dana W.", hood: "Brentwood" },
  { quote: "17 minutes door to door. I timed it twice because I didn't believe it.", name: "Alex C.", hood: "Downtown Core" },
];

const Card = ({ quote, name, hood }) => (
  <div className="mx-3 flex h-[250px] w-[340px] flex-col justify-between self-start rounded-3xl border border-forest/10 bg-white p-8 shadow-[0_20px_40px_-30px_rgba(4,47,30,0.25)] sm:w-[400px]">
    <div>
      <div className="flex gap-1">
        {["s1", "s2", "s3", "s4", "s5"].map((k) => (
          <Star key={k} className="h-4 w-4 fill-fresh text-fresh" />
        ))}
      </div>
      <p className="mt-5 font-syne text-lg font-bold leading-snug tracking-tight text-forest">
        “{quote}”
      </p>
    </div>
    <p className="mt-6 text-sm font-semibold text-forest/60">
      {name} <span className="text-forest/35">— {hood}</span>
    </p>
  </div>
);

export const Testimonials = () => (
  <section id="love" data-testid="testimonials-section" className="py-24 lg:py-36">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <Chapter number="04" label="Word on the Street" />
        <div className="mt-6 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <h2 className="font-syne text-4xl font-extrabold leading-[1.02] tracking-tighter text-forest sm:text-5xl">
            Calgary already
            <br />
            <span className="text-fresh">loves us.</span>
          </h2>
          <p className="flex items-center gap-2 pb-1 text-sm font-bold text-forest/60">
            <Star className="h-4 w-4 fill-fresh text-fresh" />
            4.9 average across early-access orders
          </p>
        </div>
      </Reveal>
    </div>
    <Reveal delay={0.15}>
      <div className="mt-14">
        <Marquee speed={32} pauseOnHover gradient={false} autoFill>
          {QUOTES.map((q) => (
            <Card key={q.name} {...q} />
          ))}
        </Marquee>
      </div>
    </Reveal>
  </section>
);
